import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "form-field-floating active my-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "form-field-floating reactive active my-4" }
const _hoisted_7 = {
  key: 1,
  class: "text-red"
}
const _hoisted_8 = {
  key: 2,
  class: "text-red"
}
const _hoisted_9 = { class: "flex gap-2" }

import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesAidesFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        libelle: "",
        type_aide: "FAQ"
    });
    const errors = reactive({
        libelle: "",
        type_aide: ""
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.categorie) {
            const item = form_datas.categorie as any;
            formData.id = item.id;
            formData.libelle = item.libelle;
            formData.type_aide = item.type_aide;
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="La libelle est requise";
            isValid = false;
        }

        if (!formData.type_aide || ["FAQ", "TUTORIEL"].lastIndexOf(formData.type_aide) == -1) {
            errors.type_aide ="Le type est invalide";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                libelle: formData.libelle,
                type_aide: formData.type_aide,
            };
            await axios.post(`/backoffice/categories-aides/save`, formToUpload);
            router.push('/app/categories-aides/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Catégories Aides / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "type_aide",
            id: "type_aide",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.type_aide) = $event))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("option", {
              value: "FAQ",
              selected: ""
            }, "FAQ", -1),
            _createElementVNode("option", {
              value: "TUTORIEL",
              selected: ""
            }, "Tutoriel", -1)
          ]))], 512), [
            [_vModelSelect, formData.type_aide]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "categorie" }, [
            _createTextVNode("Type "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['type_aide'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors['type_aide']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.libelle) = $event)),
            name: "libelle",
            id: "libelle",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.libelle]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "libelle" }, [
            _createTextVNode("Libellé "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['libelle'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errors['libelle']), 1))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"]),
          _cache[7] || (_cache[7] = _createElementVNode("button", { class: "btn stroke black lg" }, [
            _createElementVNode("span", null, "Effacer")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})